if ( $('section#business-input').length ) {
  let wpLocale = $('body').attr('data-wp-locale');

  const partners_locale = $('#business-input').attr('data-partners-locale');
  if(partners_locale.length !== 0 && partners_locale !== 'default' && isValidLocale(partners_locale)){
    wpLocale = partners_locale;
  }

  function questionnaire() {
    let params = {};
    params.reason = $('#business-input').attr('data-reason');
    params.referrer = $('#business-input').attr('data-referrer');
    params.partnersLocale = $('#business-input').attr('data-partners-locale');

    if (businessInput.company && businessInput.company.code.id.length !== 0) {
      params.type = businessInput.company.code.type;
      params.id = businessInput.company.code.id;
      if(businessInput.company.name) params.company = businessInput.company.name;

    }else if(businessInput.$input.val()){
      params.id = businessInput.$input.val();
    }

    const queryParams = $.param(params);

    return location.href = $('section#business-input').attr('data-e-test-url') + '?' + queryParams;
  }

  const businessInput = new BusinessInput($('#business-input'), undefined, wpLocale, undefined, questionnaire);
}
